import { rm } from 'utils';
import { useCountdown, pad } from 'components/CountdownAd/useCountdown';
import styles from './styles.scss';
import { CountdownAdProps } from 'components/CountdownAd/props';
import cn from 'classnames';
import { IconTag } from 'components/Shared/Icon';
import { useEffect, useMemo, useState } from 'react';

const TimePart = ({ time, caption }: { time: string; caption: string }) => (
  <div className={styles.timePart}>
    <div className={styles.time}>
      {time}
      <div className={styles.line} />
    </div>
    <div className={styles.caption}>{caption}</div>
  </div>
);

export const CountdownAd = (props: CountdownAdProps) => {
  const isContentPage = props.appearance === 'content-page';
  const time = useCountdown(props.endTime);
  const [day, hour, min, sec] = useMemo(() => {
    return rm('countdown_time').split(';');
  }, []);
  const [days, setDays] = useState('');
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [seconds, setSeconds] = useState('');

  const hasUrl = props.url;

  useEffect(() => {
    setDays(pad(time.days));
    setHours(pad(time.hours));
    setMinutes(pad(time.minutes));
    setSeconds(pad(time.seconds));
  }, [time]);

  return (
    <div className={cn(styles.countdownAd, props.className)}>
      <span className={styles.row}>
        <IconTag className={styles.icon} />
        {hasUrl && (
          <a
            className={cn(styles.title, { [styles.contentPageTitle]: isContentPage })}
            href={props.url}
          >
            {props.title}
          </a>
        )}
        {!hasUrl && (
          <div className={cn(styles.title, { [styles.contentPageTitle]: isContentPage })}>
            {props.title}
          </div>
        )}
      </span>
      <div className={styles.timeWrapper}>
        <TimePart time={days} caption={day} />
        <TimePart time={hours} caption={hour} />
        <TimePart time={minutes} caption={min} />
        <TimePart time={seconds} caption={sec} />
      </div>
    </div>
  );
};
